import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["caption"];

  refresh() {
    const toggles = Array.from(this.element.querySelectorAll('input[type="checkbox"]'));
    const visible = toggles.filter((toggle) => toggle.checked).length;

    this.captionTarget.textContent = visible === toggles.length ? "All Services Visible" : `${visible} of ${toggles.length} Visible`;
  }
}
